var React = require('react');

function FilledShield (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3z"}));
}

FilledShield.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor","strokeWidth":"0","height":"1em","width":"1em"};

module.exports = FilledShield;

FilledShield.default = FilledShield;
